module.exports = __webpack_public_path__ + "static/img/gongye.f82a9935.png";